import * as React from "react";
import styled from "styled-components";

import Modal from "../../../components/reusable/reactModal";
import { redesignTheme } from "../../theme/theme";

const StyledModalBody = styled.div`
  margin: ${redesignTheme.spacing[4.5]} 0;
`;

const StyledModalContents = styled.div`
  border-top: 1px solid ${redesignTheme.color.grayAlpha100};
  padding: 16px 24px 0 24px;
`;

const AttachmentModal = ({ attachmentUrl, closeModal }): React.ReactElement => {
  return (
    <Modal
      ariaLabel="Attachment preview modal"
      close={closeModal}
      showDialog={!!attachmentUrl}
      testId="attachment-modal"
      title="Attachment"
      style={{
        width: "fit-content",
        height: "auto",
        minWidth: "480px",
        maxWidth: "640px",
        margin: "5vh auto",
      }}
    >
      <StyledModalBody>
        <StyledModalContents>
          <img
            src={attachmentUrl}
            alt="Attachment"
            style={{
              width: "auto",
              display: "block",
              margin: "0 auto",
            }}
          />
        </StyledModalContents>
      </StyledModalBody>
    </Modal>
  );
};

export default AttachmentModal;
